import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import ReactPixel from 'react-facebook-pixel';
import { App } from './App';
// Initialize Meta (Facebook) Pixel and fire a PageView
const PIXEL_ID = '1376744403856001';
ReactPixel.init(PIXEL_ID);
ReactPixel.pageView();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-278" />);
}